import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, withModifiers as _withModifiers, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "card" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "card-header border-0 pt-6" }, [
  /*#__PURE__*/_createElementVNode("h3", { class: "card-title" }, "充值追踪")
], -1)
const _hoisted_3 = { class: "card-body pt-0" }
const _hoisted_4 = /*#__PURE__*/_createTextVNode("查询")
const _hoisted_5 = {
  key: 0,
  class: "mb-5 p-4 bg-light-primary rounded"
}
const _hoisted_6 = /*#__PURE__*/_createElementVNode("strong", null, "用户:", -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("strong", null, "余额:", -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("strong", null, "积分:", -1)
const _hoisted_9 = { class: "text-primary mb-3" }
const _hoisted_10 = { class: "text-muted ms-2" }
const _hoisted_11 = {
  key: 0,
  class: "mb-2"
}
const _hoisted_12 = /*#__PURE__*/_createElementVNode("strong", null, "来源:", -1)
const _hoisted_13 = { key: 0 }
const _hoisted_14 = /*#__PURE__*/_createTextVNode(" | ")
const _hoisted_15 = /*#__PURE__*/_createElementVNode("strong", null, "订单号:", -1)
const _hoisted_16 = { key: 0 }
const _hoisted_17 = /*#__PURE__*/_createTextVNode(" | ")
const _hoisted_18 = /*#__PURE__*/_createElementVNode("strong", null, "支付宝交易号:", -1)
const _hoisted_19 = { key: 1 }
const _hoisted_20 = /*#__PURE__*/_createTextVNode(" | ")
const _hoisted_21 = /*#__PURE__*/_createElementVNode("strong", null, "微信交易号:", -1)
const _hoisted_22 = {
  key: 1,
  class: "mb-2"
}
const _hoisted_23 = {
  key: 2,
  class: "mb-2 text-danger"
}
const _hoisted_24 = { key: 3 }
const _hoisted_25 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_26 = { key: 0 }
const _hoisted_27 = { key: 0 }
const _hoisted_28 = {
  key: 1,
  class: "text-muted"
}
const _hoisted_29 = {
  key: 1,
  class: "text-muted"
}
const _hoisted_30 = {
  key: 4,
  class: "text-muted mt-2"
}

import { ref } from "vue";
import ApiService from "@/core/services/ApiService";


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const loading = ref(false);
const queried = ref(false);
const userData = ref(null);
const traces = ref([]);

const formData = ref({
  mobile: "",
  dateRange: [],
  amount: "",
});

const paymentChannel = (trace) => {
  const note = trace.abr?.note || "";
  if (note.includes("支付宝")) return { label: "支付宝", type: "primary" };
  if (note.includes("微信")) return { label: "微信", type: "success" };
  if (note.includes("人工")) return { label: "人工", type: "warning" };
  if (trace.source_pr?.wx_transaction_id) return { label: "微信", type: "success" };
  if (trace.source_pr?.alipay_trade_no) return { label: "支付宝", type: "primary" };
  return { label: "其他", type: "info" };
};

const query = () => {
  if (!formData.value.mobile) {
    return;
  }
  loading.value = true;
  queried.value = true;

  let qs = `?mobile=${formData.value.mobile}`;
  if (formData.value.dateRange && formData.value.dateRange.length === 2) {
    qs += `&from=${formData.value.dateRange[0]}&to=${formData.value.dateRange[1]}`;
  }
  if (formData.value.amount) {
    qs += `&amount=${formData.value.amount}`;
  }

  ApiService.setHeader();
  ApiService.get("admin/payment_traces", qs)
    .then(({ data }) => {
      if (data.success === false) {
        userData.value = null;
        traces.value = [];
        alert(data.message);
        return;
      }
      userData.value = data.user;
      traces.value = data.traces;
    })
    .catch(() => {
      userData.value = null;
      traces.value = [];
    })
    .finally(() => {
      loading.value = false;
    });
};

return (_ctx: any,_cache: any) => {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_tag = _resolveComponent("el-tag")!
  const _component_vxe_column = _resolveComponent("vxe-column")!
  const _component_vxe_table = _resolveComponent("vxe-table")!
  const _component_el_empty = _resolveComponent("el-empty")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createVNode(_component_el_form, {
        inline: true,
        model: formData.value,
        onSubmit: _withModifiers(query, ["prevent"])
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_form_item, { label: "手机号" }, {
            default: _withCtx(() => [
              _createVNode(_component_el_input, {
                modelValue: formData.value.mobile,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((formData.value.mobile) = $event)),
                placeholder: "请输入手机号",
                clearable: ""
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_form_item, { label: "时间范围" }, {
            default: _withCtx(() => [
              _createVNode(_component_el_date_picker, {
                modelValue: formData.value.dateRange,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((formData.value.dateRange) = $event)),
                type: "datetimerange",
                "range-separator": "至",
                "start-placeholder": "开始时间",
                "end-placeholder": "结束时间",
                "value-format": "YYYY-MM-DD HH:mm:ss"
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_form_item, { label: "金额" }, {
            default: _withCtx(() => [
              _createVNode(_component_el_input, {
                modelValue: formData.value.amount,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((formData.value.amount) = $event)),
                placeholder: "可选",
                clearable: "",
                style: {"width":"100px"}
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_form_item, null, {
            default: _withCtx(() => [
              _createVNode(_component_el_button, {
                type: "primary",
                onClick: query,
                loading: loading.value
              }, {
                default: _withCtx(() => [
                  _hoisted_4
                ]),
                _: 1
              }, 8, ["loading"])
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["model", "onSubmit"]),
      (userData.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
            _hoisted_6,
            _createTextVNode(" " + _toDisplayString(userData.value.nickname) + " (" + _toDisplayString(userData.value.mobile) + ") | ", 1),
            _hoisted_7,
            _createTextVNode(" " + _toDisplayString(userData.value.balance) + " | ", 1),
            _hoisted_8,
            _createTextVNode(" " + _toDisplayString(userData.value.point), 1)
          ]))
        : _createCommentVNode("", true),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(traces.value, (trace, idx) => {
        return (_openBlock(), _createElementBlock("div", {
          key: idx,
          class: "mb-8 border rounded p-4"
        }, [
          _createElementVNode("h5", _hoisted_9, [
            _createTextVNode(" 充值 #" + _toDisplayString(trace.abr.id) + " — ¥" + _toDisplayString(trace.abr.balance) + " ", 1),
            _createVNode(_component_el_tag, {
              size: "small",
              type: trace.abr.status === 'done' ? 'success' : 'danger',
              class: "ms-2"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(trace.abr.status), 1)
              ]),
              _: 2
            }, 1032, ["type"]),
            _createVNode(_component_el_tag, {
              size: "small",
              type: paymentChannel(trace).type,
              class: "ms-2"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(paymentChannel(trace).label), 1)
              ]),
              _: 2
            }, 1032, ["type"]),
            _createElementVNode("span", _hoisted_10, _toDisplayString(trace.abr.created_at), 1)
          ]),
          (trace.abr.note)
            ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                _hoisted_12,
                _createTextVNode(" " + _toDisplayString(trace.abr.note) + " ", 1),
                (trace.source_pr)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_13, [
                      _hoisted_14,
                      _hoisted_15,
                      _createTextVNode(" " + _toDisplayString(trace.source_pr.no) + " ", 1),
                      (trace.source_pr.alipay_trade_no)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_16, [
                            _hoisted_17,
                            _hoisted_18,
                            _createTextVNode(" " + _toDisplayString(trace.source_pr.alipay_trade_no), 1)
                          ]))
                        : _createCommentVNode("", true),
                      (trace.source_pr.wx_transaction_id)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_19, [
                            _hoisted_20,
                            _hoisted_21,
                            _createTextVNode(" " + _toDisplayString(trace.source_pr.wx_transaction_id), 1)
                          ]))
                        : _createCommentVNode("", true)
                    ]))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true),
          (trace.credit_bcl)
            ? (_openBlock(), _createElementBlock("div", _hoisted_22, " ✅ 余额入账: +" + _toDisplayString(trace.credit_bcl.balance) + " (BCL#" + _toDisplayString(trace.credit_bcl.id) + ") ", 1))
            : (_openBlock(), _createElementBlock("div", _hoisted_23, " ❌ 未找到入账记录 ")),
          (trace.consumptions.length > 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
                _createVNode(_component_vxe_table, {
                  data: trace.consumptions,
                  border: "",
                  size: "small",
                  class: "mt-2"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_vxe_column, {
                      title: "消费记录",
                      "min-width": "140"
                    }, {
                      default: _withCtx(({ row }) => [
                        _createTextVNode(" PR#" + _toDisplayString(row.payment_record.id) + " ", 1),
                        _hoisted_25,
                        _createTextVNode("¥" + _toDisplayString(row.payment_record.balance) + " ", 1),
                        (row.payment_record.point > 0)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_26, " + " + _toDisplayString(row.payment_record.point) + "积分", 1))
                          : _createCommentVNode("", true)
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_vxe_column, {
                      title: "消费状态",
                      width: "90"
                    }, {
                      default: _withCtx(({ row }) => [
                        _createVNode(_component_el_tag, {
                          size: "small",
                          type: row.payment_record.status === 'paid' ? 'success' : 'info'
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(row.payment_record.status), 1)
                          ]),
                          _: 2
                        }, 1032, ["type"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_vxe_column, {
                      title: "套系",
                      field: "payment_record.box_name",
                      "min-width": "140"
                    }),
                    _createVNode(_component_vxe_column, {
                      title: "抽奖结果",
                      "min-width": "160"
                    }, {
                      default: _withCtx(({ row }) => [
                        (row.box_record)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_27, [
                              _createTextVNode(_toDisplayString(row.box_record.product_name) + " ", 1),
                              _createVNode(_component_el_tag, {
                                size: "small",
                                class: "ms-1"
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(row.box_record.item_type), 1)
                                ]),
                                _: 2
                              }, 1024)
                            ]))
                          : (_openBlock(), _createElementBlock("span", _hoisted_28, "—"))
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_vxe_column, {
                      title: "物品状态",
                      width: "100"
                    }, {
                      default: _withCtx(({ row }) => [
                        (row.pocket_item)
                          ? (_openBlock(), _createBlock(_component_el_tag, {
                              key: 0,
                              size: "small"
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(row.pocket_item.status_display || row.pocket_item.status), 1)
                              ]),
                              _: 2
                            }, 1024))
                          : (_openBlock(), _createElementBlock("span", _hoisted_29, "—"))
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_vxe_column, {
                      title: "时间",
                      field: "payment_record.created_at",
                      width: "160"
                    })
                  ]),
                  _: 2
                }, 1032, ["data"])
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_30, " 无关联消费（余额可能用于后续消费） "))
        ]))
      }), 128)),
      (queried.value && traces.value.length === 0)
        ? (_openBlock(), _createBlock(_component_el_empty, {
            key: 1,
            description: "该时间范围内无充值记录"
          }))
        : _createCommentVNode("", true)
    ])
  ]))
}
}

})